module.exports = __webpack_public_path__ + "accessibility-bad.079399ffa3a6172f01cac2ca7e71c447.hashedasset.png";